"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
require("./feedback-popup.scss");
class FeedbackPopup extends React.Component {
    componentDidMount() {
        const { autoClose, onClose } = this.props;
        document.addEventListener('keydown', this.handleEscKey, false);
        if (autoClose && onClose) {
            setTimeout(onClose, 4000);
        }
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleEscKey, false);
    }
    handleEscKey = (event) => {
        if (event.keyCode === 27 && this.props.onClose) {
            this.props.onClose();
        }
    };
    render() {
        const { type, title, children, onClose } = this.props;
        return (React.createElement("div", { className: 'Feedback Feedback--popup ' + (type ? 'Feedback--' + type : ''), "data-testid": "feedback-popup" },
            React.createElement("div", { className: "Feedback-icon" },
                React.createElement("svg", { viewBox: "0 0 960 960", role: "presentation", className: "Icon" },
                    React.createElement("path", { d: "M957 364.6c5.3 14 4.3 27.3-3 40-32.7 60-102.3 135.3-209 226 28 115.3 44.7 207.7 50 277 1.3 18.7-6 33.3-22 44-8.7 5.3-17.3 8-26 8-6.7 0-14-1.7-22-5-11.3-6.7-29.7-16-55-28-90-44.7-153.3-78.7-190-102-36.7 23.3-100 57.3-190 102-25.3 12-43.7 21.3-55 28-16.7 8.7-32.7 7.7-48-3-16-10.7-23.3-25.3-22-44 5.3-69.3 22-161.7 50-277-106.7-90.7-176.3-166-209-226-7.3-12.7-8.3-26-3-40 4.7-14 13.3-23.3 26-28 37.3-16.7 131.7-27.7 283-33 54.7-158.7 99.3-255.3 134-290 10.7-9.3 22-14 34-14 12.7 0 23.7 4.7 33 14 35.3 34.7 80.3 131.3 135 290 151.3 5.3 245.7 16.3 283 33 12.7 5.3 21.3 14.7 26 28z" }))),
            React.createElement("span", { className: "Feedback-title" }, title),
            " ",
            children,
            onClose && (React.createElement("i", { className: "Feedback-dismiss", onClick: onClose, "data-testid": "feedback-dismiss" },
                React.createElement("svg", { viewBox: "0 0 960 960", role: "presentation", className: "Icon" },
                    React.createElement("path", { d: "M628 480l189 190c8.7 8 13.7 17.5 15 28.5s-1.3 20.2-8 27.5c-28.7 36.7-61.3 69.3-98 98-7.3 6.7-16.5 9.3-27.5 8s-20.8-6-29.5-14L480 628 290 818c-8 8-17.5 12.7-28.5 14s-20.5-1.3-28.5-8c-36-28.7-68.3-61-97-97-6.7-8-9.3-17.5-8-28.5 1.3-11 6-20.5 14-28.5l190-190-189-189c-8.7-8.7-13.7-18.5-15-29.5-1.3-11 1.3-20.2 8-27.5 28-36 60.3-68.7 97-98 8-6.7 17.5-9.3 28.5-8s20.5 6.3 28.5 15l190 181 189-181c8.7-8.7 18.5-13.7 29.5-15s20.2 1.3 27.5 8c36.7 28.7 69.3 61.3 98 98 6.7 7.3 9.3 16.5 8 27.5s-6.3 20.8-15 29.5L628 480z" }))))));
    }
}
exports.default = FeedbackPopup;
